import { createContext, useContext, useEffect, useState, useMemo } from 'react';
import api from '../lib/api';

const MaintenanceContext = createContext({
  isMaintenanceMode: false,
  loading: true,
  settings: {}
});

export const MaintenanceProvider = ({ children }) => {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const [loading, setLoading] = useState(true);
  const [settings, setSettings] = useState({});

  useEffect(() => {
    const checkMaintenance = async () => {
      try {
        const res = await api.get('/settings/maintenance');
        if (res.data) {
          setIsMaintenanceMode(res.data.maintenance_mode === true);
          setSettings(res.data);
        }
      } catch {
        // Silently fail - maintenance mode off by default
        setIsMaintenanceMode(false);
      } finally {
        setLoading(false);
      }
    };

    checkMaintenance();
  }, []); // Empty deps is intentional - only run on mount

  // Memoize context value to prevent unnecessary re-renders
  const value = useMemo(() => ({ 
    isMaintenanceMode, 
    loading, 
    settings 
  }), [isMaintenanceMode, loading, settings]);

  return (
    <MaintenanceContext.Provider value={value}>
      {children}
    </MaintenanceContext.Provider>
  );
};

export const useMaintenance = () => {
  const context = useContext(MaintenanceContext);
  if (!context) {
    throw new Error('useMaintenance must be used within a MaintenanceProvider');
  }
  return context;
};
